import React from 'react';
import { Container, Row, Col, Card, Button, Badge, Spinner } from 'react-bootstrap';
import { colors } from '../../brand-colors';

const successButtonStyle = {
  background: `linear-gradient(180deg, ${colors.goldMid} 0%, ${colors.goldDark} 100%)`,
  border: 'none',
  color: colors.greyDarkest,
  fontWeight: '600',
  padding: '0.75rem 2rem',
  fontSize: '1.1rem',
  transition: 'all 0.2s ease',
};

const successButtonHoverStyle = {
  background: `linear-gradient(180deg, ${colors.goldLight} 0%, ${colors.gold} 100%)`,
};

// IP category display names
const CATEGORY_NAMES = {
  processes: 'Processes & Workflows',
  cultural: 'Cultural & Experiential',
  training: 'Training & Education',
  mental_models: 'Mental Models',
  customer_insights: 'Customer Insights',
  branding: 'Branding & Marketing',
  inventions: 'Inventions & Ideas',
  supplier: 'Network Know-How',
  software: 'Software & Tools',
  design: 'Design Innovations'
};

/**
 * TransitionScreen - Brief screen showing selected IP before codification
 * Shown after user selects an IP asset from V2 output to codify in V1
 */
function TransitionScreen({ selectedIp, userName, onContinue, loading }) {
  const categoryName = CATEGORY_NAMES[selectedIp?.category] || selectedIp?.category || 'IP Asset';

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="shadow">
            <Card.Body className="p-5">
              <div className="text-center mb-4">
                <span style={{ fontSize: '4rem' }}>🎯</span>
              </div>

              <h2 className="text-center mb-3" style={{ color: '#1a365d' }}>
                Great Choice, {userName}!
              </h2>

              <p className="text-center text-muted mb-4">
                Now let's turn this discovery into a complete, documented framework.
              </p>

              {/* Selected IP Card */}
              <Card className="mb-4" style={{ backgroundColor: '#f0fff4', borderColor: '#9ae6b4' }}>
                <Card.Body className="p-4">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <Badge
                      style={{
                        backgroundColor: selectedIp?.value === 'high' ? '#2f855a' : selectedIp?.value === 'medium' ? '#d69e2e' : '#718096'
                      }}
                    >
                      {selectedIp?.value === 'high' ? 'High Value' : selectedIp?.value === 'medium' ? 'Medium Value' : 'Potential'}
                    </Badge>
                    <Badge style={{ backgroundColor: colors.greyMid }}>
                      {categoryName}
                    </Badge>
                  </div>

                  <h4 className="mb-2" style={{ color: '#276749' }}>{selectedIp?.name || 'Selected IP'}</h4>
                  <p className="mb-0 text-muted">{selectedIp?.description || ''}</p>
                </Card.Body>
              </Card>

              {/* What happens next */}
              <div className="p-3 mb-4" style={{ backgroundColor: '#f8fafc', borderRadius: '8px' }}>
                <h6 className="mb-3" style={{ color: '#1a365d' }}>What happens next:</h6>
                <ol className="mb-0 ps-3" style={{ color: '#4a5568' }}>
                  <li className="mb-2">We'll ask targeted questions about this specific IP</li>
                  <li className="mb-2">Extract your unique methodology across 5 layers</li>
                  <li className="mb-2">Name your framework and generate a polished document</li>
                  <li>Get your IP framework as a PDF ready to publish</li>
                </ol>
              </div>

              <Button
                size="lg"
                className="w-100"
                onClick={onContinue}
                disabled={loading}
                style={successButtonStyle}
                onMouseEnter={(e) => Object.assign(e.target.style, successButtonHoverStyle)}
                onMouseLeave={(e) => Object.assign(e.target.style, successButtonStyle)}
              >
                {loading ? (
                  <><Spinner size="sm" className="me-2" />Preparing extraction...</>
                ) : (
                  <>Start Deep Extraction</>
                )}
              </Button>

              <p className="text-center text-muted mt-3 small">
                This takes about 10-15 minutes. Your progress is saved automatically.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default TransitionScreen;
